import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import numeral from "numeral";
import moment from 'moment';
import { Info, Assessment } from '@material-ui/icons';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';

const styles = theme => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 'bold'
  },
  panel: {
    paddingLeft: 0,
    backgroundColor: 'lightblue'
  },
  icon: {
    width: 48,
    height: 48,
    color: 'black'
  },
  card: {
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
    width: '100%'
  },

  gutterBottom: {
    marginTop: '5px',
    marginBottom: '10px'
  }
});


const PageInfo = ({ classes, pageMetrics, contentItem, recommendations }) => (
  <div className={classes.root}>
    <Card className={classes.card} elevation={0}>
      <CardHeader classes={{ title: classes.heading }} title="Info" avatar={(
        <Avatar>
          <Info className={classes.icon} />
        </Avatar>)}>
      </CardHeader>
      <CardContent className={classes.root}>

        <Badge badgeContent={recommendations.messages.length} color="primary">
          <Typography variant="title">{contentItem.name}</Typography>
        </Badge>
        <Typography className={classes.gutterBottom} component="p">Page</Typography>

        <Typography variant="title" component="h3">
          {contentItem.templateName}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Template</Typography>

        <Typography variant="title" component="h3">
          {contentItem.path.replace("/sitecore/content", "")}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Path</Typography>

        <Typography variant="title" component="h3">
          {moment(contentItem.lastUpdated).format('MMMM Do YYYY')}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">last updated on</Typography>

        <Typography variant="title" component="h3">
          {contentItem.lastUpdatedBy}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">last updated by</Typography>

        <Typography variant="title" component="h3">
          {contentItem.personalizationDetails.isUsingPersonalization ? "Yes" : "No"}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Personalized</Typography>
      </CardContent>
    </Card >

    <Card className={classes.root}>
      <CardHeader classes={{ title: classes.heading }} title="Metrics" avatar={(
        <Avatar>
          <Assessment className={classes.icon} />
        </Avatar>)}>
      </CardHeader>
      <CardContent>
        <Typography variant="title" component="h3">
          {numeral(pageMetrics.value).format("0,0")}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Engagement Value</Typography>

        <Typography variant="title" component="h3">
          {numeral(pageMetrics.visits).format("0,0")}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Visits</Typography>

        <Typography variant="title" component="h2">
          {numeral(pageMetrics.valuePerVisit).format("0,0.00")}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Value per Visit</Typography>

        <Typography variant="title" component="h2">
          {recommendations.pageValuePotential == 0 ? "Above Average!" : numeral(recommendations.pageValuePotential).format("0,0")}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Potential</Typography>

        <Typography variant="title" component="h2">
          {recommendations.messages.length}
        </Typography>
        <Typography className={classes.gutterBottom} component="p">Recommendations</Typography>
      </CardContent>
    </Card>
  </div>
);

export default withStyles(styles)(PageInfo);


// WEBPACK FOOTER //
// ./src/components/PageInfo.js